import { Component, OnInit } 									    from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } 	    from '@angular/forms';
import { ErrorStateMatcher } 										from '@angular/material/core';

import { Router, ActivatedRoute } 								    from '@angular/router';
import { first } 												    from 'rxjs/operators';

import { AlertService, PhotoauthService } 					    	from '../_services';

import { Subject } 													from 'rxjs';
import { Observable,throwError } 									from 'rxjs';

import { WebcamImage, WebcamInitError, WebcamUtil } 				from 'ngx-webcam';
import { NgxSpinnerService }                                        from 'ngx-spinner';
import { HttpHeaders, HttpClient }                              	from '@angular/common/http';

import { Globals}     												from '../_helpers';


export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
	    const isSubmitted = form && form.submitted;
	    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}


@Component({
  selector: 'student-upload-pic',
  templateUrl: './upload-pic.component.html',
})

export class UploadpicComponent implements OnInit{
  	fileFormControl = new FormControl('', [
	    Validators.required,
	]);
	
  	matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isPicTaken = true;
    errorMsg : string;
    returnUrl: string;
    imagePath : string;
    imgfile : File ;
    imageError : boolean;
    exam_id: number;
    localData = {};
    res = {};
	geoIPData = {};
	geoIP = '';
	city = '';
	region = '';
	postal = '';
	loc = '';
	countryip = ''; 
	settime;	

    /* webcam Settings */
    public iscameraLoaded:boolean = false;
	public showWebcam = true;
	public allowCameraSwitch = true;
	public multipleWebcamsAvailable = false;
	public deviceId: string;
	public videoOptions: MediaTrackConstraints = {
	// width: {ideal: 1024},
	// height: {ideal: 576}
	};
	public errors: WebcamInitError[] = [];

	// latest snapshot
	public webcamImage: WebcamImage = null;

	// webcam snapshot trigger
	private trigger: Subject<void> = new Subject<void>();
	// switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
	private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private photoauthService: PhotoauthService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner :NgxSpinnerService,
        private http: HttpClient        
    ) {}

    ngOnInit() {
    	this.localData = JSON.parse(localStorage.getItem('currentUser'));
    	this.imageError = false;
    	this.isPicTaken = false;
    	this.imagePath = '/assets/images/pic-upload.png';

        // get return url from route parameters or default to '/'
        this.returnUrl = '/';

		WebcamUtil.getAvailableVideoInputs()
		.then((mediaDevices: MediaDeviceInfo[]) => {
			this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
		});
    }

    /*onSelectFile(event) {
    	this.imageError = false;
    	this.imgfile = event.target.files[0];
	    if (event.target.files && event.target.files[0]) {
		    var reader = new FileReader();
		    reader.readAsDataURL(event.target.files[0]); 

		    reader.onload = (event) => { 
		        this.imagePath = event.target.result;
		    }
	    }
	}*/

	public triggerSnapshot(): void {
		this.trigger.next();
		this.imagePath = this.webcamImage.imageAsDataUrl;
		this.isPicTaken = false;
		this.imageError = false;

	}

	public toggleWebcam(): void {
		this.showWebcam = !this.showWebcam;
	}

	public handleInitError(error: WebcamInitError): void {
		this.errors.push(error);
	}

	public showNextWebcam(directionOrDeviceId: boolean|string): void {
		// true => move forward through devices
		// false => move backwards through devices
		// string => move to device with given deviceId
		this.nextWebcam.next(directionOrDeviceId);
	}

	public handleImage(webcamImage: WebcamImage): void {
		this.webcamImage = webcamImage;
	}

	public cameraWasSwitched(deviceId: string): void {
		//console.log('active device: ' + deviceId);
		this.deviceId = deviceId;
	}

	public get triggerObservable(): Observable<void> {
		return this.trigger.asObservable();
	}

	public get nextWebcamObservable(): Observable<boolean|string> {
		return this.nextWebcam.asObservable();
	}

	public webCameScreen(): void{
		this.isPicTaken = true;
        this.settime = setInterval(() => {
		  this.iscameraLoaded = true;
		  clearInterval(this.settime);
		}, 5000);		
	}

	onFileSubmit(){
		this.submitted = true;
		this.spinner.show();
		if(this.webcamImage && this.webcamImage.imageAsDataUrl){
			this.photoauthService.photosave(this.globals.root_url,this.localData['usercode'],this.localData['id'], this.localData['exam_id'], this.webcamImage.imageAsDataUrl)
            .pipe(first())
            .subscribe(
    	        data => {
                    if(data.code == 1000){
                        this.imageError = false;
                        this.router.navigateByUrl('/exam-list');                        
					    this.setGeoLocation();
                        
                    }
                    else if(data.status == 'COM_TOKEN_ERROR'){
                    	this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else{
                        this.imageError = true;
                        this.errorMsg = data.status;
                        this.loading = false;
                    }
                    this.spinner.hide();
    	        },
    	        error => {
                    this.imageError = true;
                    this.errorMsg = 'Invalid Image !!';
    	            this.alertService.error(error);
    	            this.loading = false;
    	            this.spinner.hide();
    	        }
    	    );
		}
		else{
			this.imageError = true;
			this.spinner.hide();
		}
	}

	private setGeoLocation(){	
		this.geoIPData = JSON.parse(localStorage.getItem('geoIPData'));
		var geoipresponse = this.geoIPData;
		if(geoipresponse != undefined)
		{
			this.geoIP = geoipresponse['ip'];
			this.city = geoipresponse['city'];
			this.region = geoipresponse['region'];
			this.postal = geoipresponse['postal'];
			this.loc = geoipresponse['loc'];
			this.countryip = geoipresponse['country'];
		}
		this.photoauthService.geoLocation(this.globals.root_url,this.localData['id'], this.localData['exam_id'], 'web', this.geoIP, this.city, this.region, this.postal, this.loc, this.countryip)
        .pipe(first())
        .subscribe(
	        data => {
                if(data.code == 1000){
            		// save in hidden.
            		//localStorage.removeItem('geoIPData');
                }
                else{
                    this.errorMsg = data.status;
                }
	        },
	        error => {
	            this.alertService.error(error);
	        }
	    );
	}
	private pleasewait()
	{
		console.log('Please Wait...');
	}
    public checkLogin(){
        this.localData = JSON.parse(localStorage.getItem('currentUser'));
        if(this.localData['usercode'] && this.localData['id'])
        {
            var parms = this.globals.getRandUrl('dashboard');
            localStorage.setItem('urlStep', JSON.stringify({set:parms}));
            this.router.navigateByUrl('/dashboard/'+parms);
        }
        else
        {
            localStorage.removeItem('currentUser');
            this.router.navigateByUrl('/login');
        }
    }
}
